import {useEffect, useState} from "react";
import {BASE_NAME} from "../../services/utils/ApiUrls";

const API_URL = BASE_NAME + "reservation/getAllBy";

const useFetchReservations = (servizio, sede, date) => {
    const [reservations, setReservations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [firstLoad, setFirstLoad] = useState(true);

    useEffect(() => {
        const fetchReservations = async () => {
            setLoading(true);
            setError(null);

            try {
                // Costruzione della query string solo con i parametri definiti
                const queryParams = new URLSearchParams();
                if (servizio) queryParams.append("servizio", servizio);
                if (sede) queryParams.append("sede", sede);
                if (date) queryParams.append("data", date);

                const response = await fetch(`${API_URL}?${queryParams.toString()}`);
                if (!response.ok) {
                    throw new Error("Errore nel recupero delle prenotazioni");
                }


                const data = await response.json();
                // console.log(data);
                setReservations(data.filter(reservation => {
                    return reservation.postiR > 0
                }));
            } catch (err) {
                // console.error(err);
                setError(err.message);
            } finally {
                setLoading(false);
                setFirstLoad(false);
            }
        };

        fetchReservations();
    }, [servizio, sede, date]); // Effettua la chiamata ogni volta che cambiano i parametri

    return {reservations, loading, error, firstLoad};
};

export default useFetchReservations;
